import React from 'react';

import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '#/components/ui';
import { SOCIAL_ICONS } from '#/utils';

const SOCIAL_ORDER = ['website', 'linkedin', 'instagram', 'facebook', 'twitter', 'tiktok'];

const getVisibleAndHiddenLinks = socialLinks => {
    const links = Object.entries(socialLinks || {})
        .filter(([key, value]) => value && SOCIAL_ICONS[key])
        .sort(([a], [b]) => SOCIAL_ORDER.indexOf(a) - SOCIAL_ORDER.indexOf(b));

    const visibleLinks = links.slice(0, 2);
    const hiddenLinks = links.slice(2);
    return { visibleLinks, hiddenLinks, allLinks: links };
};

const CompanySocialLinks = ({ socialLinks, showAll = false }) => {
    const { visibleLinks, hiddenLinks, allLinks } = getVisibleAndHiddenLinks(socialLinks);

    if (allLinks.length === 0) {
        return <span className='text-muted-foreground'>-</span>;
    }

    if (showAll) {
        return (
            <div className='flex items-center gap-2 flex-wrap'>
                {allLinks.map(([platform, url]) => (
                    <a key={platform} href={url} target='_blank' rel='noopener noreferrer' title={platform}>
                        {SOCIAL_ICONS[platform]}
                    </a>
                ))}
            </div>
        );
    }

    return (
        <div className='flex items-center gap-2 relative'>
            {visibleLinks.map(([platform, url]) => (
                <a key={platform} href={url} target='_blank' rel='noopener noreferrer' title={platform}>
                    {SOCIAL_ICONS[platform]}
                </a>
            ))}

            {hiddenLinks.length > 0 && (
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <button className='w-[24px] h-[24px] text-[10px] text-[#00225F] border rounded-full bg-slate-100 border-[#00225F]'>
                            +{hiddenLinks.length}
                        </button>
                    </DropdownMenuTrigger>

                    <DropdownMenuContent
                        align='end'
                        className='bg-white rounded-lg shadow-lg max-h-[450px] overflow-auto z-[9999]'
                    >
                        {hiddenLinks.map(([platform, url]) => (
                            <DropdownMenuItem key={platform} asChild>
                                <a
                                    href={url}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    className='flex items-center gap-2 text-sm text-gray-700 cursor-pointer'
                                >
                                    {SOCIAL_ICONS[platform]}
                                    <span className='capitalize'>{platform}</span>
                                </a>
                            </DropdownMenuItem>
                        ))}
                    </DropdownMenuContent>
                </DropdownMenu>
            )}
        </div>
    );
};

export { CompanySocialLinks };
